var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"title":"inventory.create.label"}},[_c('loading',{attrs:{"id":['stock', 'stock-item']}}),(_vm.inventory)?_c('inventory-form',{attrs:{"inventory":_vm.inventory}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }